import { Flex, Typography } from 'antd';
import { useTranslation } from 'translations/hooks';

import { NoConnexion } from 'ui/icons/no-connexion';

import styles from './index.module.scss';

export const OfflinePanel = () => {
  const { t } = useTranslation();

  return (
    <Flex vertical align="center" gap={16} className={styles.card}>
      <NoConnexion style={{ fontSize: 48 }} />
      <Typography.Text style={{ margin: 0 }}>
        {t('qualityControl.recordSegmentDefect.offline.title')}
      </Typography.Text>
      <Typography.Text>
        {t('qualityControl.recordSegmentDefect.offline.message')}
      </Typography.Text>
    </Flex>
  );
};
